import { useState, useRef, useEffect } from 'react';
import { Globe, Check } from 'lucide-react';
import { useTimezone } from '../contexts/TimezoneContext';

// Small clickable badge that opens a dropdown of the 12 BUSINESS_TZS.
// Designed to sit in the sidebar's user-info card so a distributed BIM
// team can flip between PT / Madrid / UTC / etc with one click. The
// choice persists via localStorage in TimezoneContext.
export const TimezoneSelector = () => {
  const { tz, setTz, zones, shortTzLabel } = useTimezone();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Close on outside click
  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="timezone-selector-btn"
        title={`Display timestamps in ${tz}. Click to change.`}
        className="inline-flex items-center gap-1.5 text-[11px] font-medium px-2 py-1 rounded-md bg-muted hover:bg-muted/70 transition-colors text-foreground"
      >
        <Globe className="h-3 w-3 text-muted-foreground" />
        {shortTzLabel()}
      </button>
      {open && (
        <div
          data-testid="timezone-selector-dropdown"
          className="absolute bottom-full left-0 mb-1 w-56 bg-card border border-border rounded-md shadow-lg z-50 py-1 max-h-72 overflow-y-auto"
        >
          {zones.map((z) => {
            const active = z.value === tz;
            return (
              <button
                key={z.value}
                type="button"
                data-testid={`timezone-option-${z.value.replace(/[/_]/g, '-')}`}
                onClick={() => { setTz(z.value); setOpen(false); }}
                className={`w-full flex items-center justify-between gap-2 px-3 py-1.5 text-xs text-left hover:bg-muted transition-colors ${
                  active ? 'text-primary font-semibold' : 'text-foreground'
                }`}
              >
                <span className="truncate">{z.label}</span>
                {active && <Check className="h-3 w-3 shrink-0" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
